package com.taocent.simple.compose.component.blockrichtext.internal.serialization

import androidx.compose.ui.text.AnnotatedString
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.blockrichtext.TableBlock
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockKind
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockSerializer
import com.taocent.simple.compose.component.richtext.core.internal.serialization.RichTextSerializer
import kotlin.reflect.KClass

@OptIn(ExperimentalBlockRichTextApi::class)
class TableBlockSerializer : BlockSerializer<TableBlock> {

    override val kind: BlockKind get() = BlockKind.TABLE

    override val blockClass: KClass<TableBlock>
        get() = TableBlock::class

    override fun typeName(): String = "table"

    override fun toJson(block: TableBlock): String {
        val rowsJson = block.rows.joinToString(",") { row ->
            val cellsJson = row.cells.joinToString(",") { cell ->
                "{\"id\":${RichTextSerializer.toJsonString(cell.cellId)},\"content\":${RichTextSerializer.toJson(cell.content)}}"
            }
            "{\"id\":${RichTextSerializer.toJsonString(row.rowId)},\"cells\":[$cellsJson]}"
        }
        return "{\"type\":\"table\",\"rows\":[$rowsJson],\"columns\":${block.columnCount}}"
    }

    override fun fromJson(root: Map<String, Any?>): TableBlock? {
        val rowItems = root["rows"] as? List<*> ?: emptyList<Any?>()
        val rows = rowItems.mapNotNull { rowItem ->
            val rowMap = rowItem as? Map<*, *> ?: return@mapNotNull null
            val cellItems = rowMap["cells"] as? List<*> ?: emptyList<Any?>()
            val cells = cellItems.mapNotNull { cellItem ->
                val cellMap = cellItem as? Map<*, *> ?: return@mapNotNull null
                val contentMap = cellMap["content"] as? Map<*, *>
                val content = if (contentMap != null) {
                    RichTextSerializer.fromJsonMap(contentMap)
                } else {
                    AnnotatedString("")
                }
                TableBlock.TableCell(content = content)
            }
            if (cells.isEmpty()) null else TableBlock.TableRow(cells = cells)
        }
        val columns = (root["columns"] as? Double)?.toInt()
            ?: rows.firstOrNull()?.cells?.size
            ?: 1
        val normalizedRows = if (rows.isEmpty()) {
            listOf(TableBlock.TableRow(cells = List(columns.coerceAtLeast(1)) { TableBlock.TableCell() }))
        } else {
            rows.map { row ->
                val cells = when {
                    row.cells.size == columns -> row.cells
                    row.cells.size < columns -> row.cells + List(columns - row.cells.size) { TableBlock.TableCell() }
                    else -> row.cells.take(columns)
                }
                row.copy(cells = cells)
            }
        }
        return TableBlock(rows = normalizedRows, columnCount = columns.coerceAtLeast(1))
    }
}
